<script setup>
defineProps({
  imgUrl: {
    type: String,
    required: true,
  },
  flagImgUrl: {
    type: String,
    default: '',
  },
  size: {
    type: Number,
    required: true,
  },
  flagPosition: {
    type: String,
    default: '0',
  },
  className: {
    type: String,
    default: '',
  },
  borderColor: {
    type: String,
    default: 'orange',
  },
});
</script>

<template>
  <div :class="[className ? `${className} ${borderColor} avatar` : `${borderColor} avatar`]">
    <img
      :src="imgUrl"
      class="avatar-img"
      loading="lazy"
      :width="`${size}`"
      :height="`${size}`"
      alt="avatar"
    />
    <img
      v-if="flagImgUrl"
      :src="flagImgUrl"
      class="flag"
      loading="lazy"
      width="24"
      height="24"
      :style="{ bottom: `${flagPosition}px`, right: `${flagPosition}px` }"
      alt="avatar flag"
    />
  </div>
</template>

<style lang="scss" scoped>
.avatar {
  position: absolute;
  width: fit-content;
  height: fit-content;

  &::before {
    content: '';
    position: absolute;
    border-radius: 50%;
    width: calc(100% + 5px);
    height: calc(100% + 5px);
    left: wds-rem(-2.5px);
    top: wds-rem(-2.6px);
  }

  &.aqua {
    &::before {
      border: wds-rem(2px) solid $wds-color-teal-lighter;
    }
  }

  &.green {
    &::before {
      border: wds-rem(2px) solid $wds-color-green-lighter;
    }
  }

  &.blue {
    &::before {
      border: wds-rem(2px) solid $wds-color-blue-light;
    }
  }

  &.violet {
    &::before {
      border: wds-rem(2px) solid $wds-color-purple-light;
    }
  }

  &.pink {
    &::before {
      border: wds-rem(2px) solid $wds-color-pink-lighter;
    }
  }

  &.yellow {
    &::before {
      border: wds-rem(2px) solid $wds-color-yellow-lighter;
    }
  }

  &.orange {
    &::before {
      border: wds-rem(2px) solid $wds-color-sunset-light;
    }
  }

  .avatar-img {
    max-width: 100%;
    border: wds-rem(3px) solid $wds-color-white;
    border-radius: 50%;
    object-fit: cover;
  }

  .flag {
    position: absolute;
    bottom: wds-rem(10px);
    right: wds-rem(10px);
    border-radius: 50%;
    z-index: $wds-z-index-toast;
  }
}
</style>
